import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";
import { Wishlist } from "./wishlist-store";

/**
 * Renders "There are N products in your wishlist" on the wishlist page.
 *
 * The labels are translated server-side and passed in via data attributes, because the count is
 * only known client-side. The plural label carries a literal `{count}` placeholder.
 */
class WishlistCounter extends Component {
  connectedCallback(): void {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.wishlistUpdate, this.#sync);
    this.#sync();
  }

  updatedCallback(): void {
    super.updatedCallback();
    // The Section Rendering API morphs (patches) existing nodes in place rather than
    // reconnecting them, so connectedCallback doesn't run again after a re-render.
    // Re-sync here too, mirroring wishlist-toggle's updatedCallback usage for the same reason.
    this.#sync();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.wishlistUpdate, this.#sync);
  }

  #sync = (): void => {
    const element = this.querySelector(".main-wishlist__count");
    if (!element) return;
    element.textContent = this.#label(Wishlist.getHandles().length);
  };

  #label(count: number): string {
    // An empty wishlist already has its own message, so the counter stays silent.
    if (count === 0) return "";
    if (count === 1) return this.dataset.labelSingular ?? "";
    return (this.dataset.labelPlural ?? "").replace("{count}", String(count));
  }
}

if (!customElements.get("wishlist-counter")) {
  customElements.define("wishlist-counter", WishlistCounter);
}
